/**
 * The rooms this browser was removed from by their host (`participants`,
 * "The host can remove a participant, and their browser remembers it").
 *
 * Only the codes, with no expiry and nothing about who or why: the room keeps
 * no list and the server is told nothing, so this is the whole of what a
 * removal leaves behind. It is not a barrier — clearing the browser forgets
 * it — and stops the visitor who simply comes back.
 */

const STORAGE_KEY = "syncani.removed-from";

/** The codes, or none for anything this module did not write. */
export function parseRemovals(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter((code): code is string => typeof code === "string");
}

function read(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === null ? [] : parseRemovals(JSON.parse(stored));
  } catch {
    return [];
  }
}

export function wasRemovedFrom(code: string): boolean {
  return read().includes(code);
}

export function rememberRemoval(code: string): void {
  if (typeof window === "undefined") return;
  const codes = read();
  if (codes.includes(code)) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...codes, code]));
  } catch {
    // A browser that refuses storage lets them back in, as every removal did
    // before this module existed.
  }
}
